/**
 * Formatea una fecha en formato relativo (hoy, ayer, etc.)
 * @param {string|Date} date - La fecha a formatear
 * @returns {string} Fecha formateada
 */
export function formatRelativeDate(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diffTime = Math.abs(now - date);
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
  // Si es hoy
  if (diffDays === 0) {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `Hoy a las ${hours}:${minutes}`;
  }
  
  // Si fue ayer
  if (diffDays === 1) {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `Ayer a las ${hours}:${minutes}`;
  }

  // Si fue anteayer
  if (diffDays === 2) {
    return 'Anteayer';
  }

  // Si fue esta semana (últimos 7 días)
  if (diffDays < 7) {
    return `Hace ${diffDays} días`;
  }

  // Para fechas más antiguas, mostrar la fecha completa
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
} 